// extracted by mini-css-extract-plugin
export var expanded = "ServiceRows-module--expanded--7c6a7";
export var readMoreButton = "ServiceRows-module--read-more-button--a9a14";
export var readMoreButtonContainer = "ServiceRows-module--read-more-button-container--126c0";
export var rows = "ServiceRows-module--rows--d6be8";
export var serviceRows = "ServiceRows-module--service-rows--bd771";
export var withReadMore = "ServiceRows-module--with-read-more--4ca80";